import { CF_ANALYTICS_TOKEN } from './env';

/** Lazily inject the Cloudflare Web Analytics beacon if a token is set.
 *
 * No-op when the token is empty (default — no analytics, no extra requests).
 * When the token is configured (via VITE_CF_ANALYTICS_TOKEN in
 * config/prod.public.env or local .env), the beacon script is appended to
 * <head> at runtime.
 *
 * Privacy stance: CF Web Analytics is cookieless and GDPR-friendly by
 * default. We send no PII, no IPs, no fingerprints — just page-view counts
 * and Core Web Vitals tied to the site token. */
export function mountAnalytics() {
  if (!CF_ANALYTICS_TOKEN) return;
  if (document.querySelector('script[data-cf-beacon]')) return; // idempotent
  const s = document.createElement('script');
  s.defer = true;
  s.src = 'https://static.cloudflareinsights.com/beacon.min.js';
  s.setAttribute('data-cf-beacon', JSON.stringify({ token: CF_ANALYTICS_TOKEN }));
  document.head.appendChild(s);
}
